import React from "react";

const DIVIDER_LINE_PATTERN = /^-+$/;

function ExplanationBlock({ text }) {
  const lines = String(text ?? "").split("\n");

  return (
    <div className="explanation-container">
      {lines.map((line, index) => {
        const key = `${index}-${line}`;

        if (DIVIDER_LINE_PATTERN.test(line.trim())) {
          return <div key={key} className="explanation-divider" aria-hidden="true" />;
        }

        return (
          <div key={key} className="explanation-line">
            {line || "\u00A0"}
          </div>
        );
      })}
    </div>
  );
}

export default ExplanationBlock;